"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var TransitionPresenterContext = /*#__PURE__*/_react.default.createContext(null);
var _default = exports.default = TransitionPresenterContext;